export enum HolidayRequestDialogMode {
  HOLIDAY_REQUEST = 0,
  HOME_OFFICE_REQUEST = 1,
}
